import React from "react"
import {TableCell, TableRow} from "@material-ui/core"

function Row({row, keys}) {
	return (
		<TableRow hover={true}>
			{keys.map((key, i) => (
				<TableCell key={i}>
					{row[key] ? row[key].split("\n").map((err, j) => <div key={j}>{err}</div>) : ""}
				</TableCell>
			))}
		</TableRow>
	)
}

export {Row}
